<div class="container-fluid w-100">
  <div class="row">
    <!-- Columna de Filtro -->
    <div class="col-md-3 px-1">
      <div class="container filter-section ">
<!--        <h4>Filtros</h4>-->
        <!-- ======= Sidebar ======= -->
        <aside id="sidebar" class="sidebar">

          <ul class="sidebar-nav" id="sidebar-nav">

            <li class="nav-item">
              <a class="nav-link " >
                <i class="bi bi-grid"></i>
                <span>Filtros</span>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link " data-bs-target="#components-nav" data-bs-toggle="collapse" href="#" aria-expanded="true">
                <i class="bi bi-menu-button-wide"></i><span>Categorías</span><i class="bi bi-chevron-down ms-auto"></i>
              </a>
              <ul id="components-nav" class="nav-content collapse show" data-bs-parent="#sidebar-nav">
                <li >
                  <a (click)="showAll()" >
                    <i  class="bi bi-circle" ></i><span>Mostrar Todas</span>
                  </a>
                </li>
                <li *ngFor="let categoria of categorias; ">
                  <a  (click)="filtroByCategoria( categoria.categoria )" >
                    <i class="bi bi-circle"></i><span>{{ categoria.categoria }}</span>
                  </a>
                </li>
              </ul>
            </li>



          </ul>

        </aside><!-- End Sidebar-->
      </div>
    </div>

    <!-- Columna de Cards de Promociones -->
    <div class="col-md-9">
      <div class="cards row" *ngIf="promotionsVisibles.length > 0; else noPromotions">
        <div  class="col-md-4 px-0 card card--1" *ngFor="let item of promotionsVisibles" >
          <a  [className]="item.categoria">
            <div class="card__img" [ngStyle]="{'background-image': 'url(' + serverImgenUrl + item.imagenPromocion + ')'}">
            </div>
            <span class="card_link">
              <div class="card__img--hover" [ngStyle]="{'background-image': 'url(' + serverImgenUrl + item.imagenPromocion + ')'}"></div>
            </span>
            <div class="card__info text-center">
              <span class="fs-6 text-secondary fw-bold">{{ item.categoria }}</span>
              <h3 class="fs-6 fw-bolder">{{ item.nombre }}</h3>
              <strong> <span style="color: var(--secondary-color)" class="fs-6 fw-bolder">${{ item.precio }}</span><br></strong>
              <button [routerLink]="['/promociones', item.codPromocionSam]" style="font-size: 1.1rem; background-color: var(--primary-color)" class="btn w-100 badge viewMore rounded-pill">
                Ver más <i class="bi bi-search"></i>
              </button>
            </div>
          </a>
        </div>
        <div class="col-12 text-center" *ngIf="promotionsVisibles.length > promotions.length">
          <button (click)="cargarMas()" class="btn viewMore">Ver más</button>
        </div>
      </div>
      <ng-template #noPromotions>
        <div class="container my-5">
          <div class="p-5 text-center bg-body-tertiary rounded-3">
            <p class=" fs-4 fw-bolder">Está muy vacío por aquí</p>
            <p class="fs-5 fw-normal">
              Pronto agregaremos más promociones a esta categoría. Mientras tanto, te invitamos a explorar nuestras otras ofertas.            </p>
            <button class="btn  rounded-5" style="background-color: var(--primary-color); color: var(--white-color)" (click)="showAll()">Ver todas las promociones</button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
